import React, { useState } from 'react'

import { PlusOutlined, QuestionCircleFilled } from '@ant-design/icons'
import { Button, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useOperatorNotification } from '@contexts/operator/OperatorNotificationContext'
import { useStorageMode } from '@contexts/operator/StorageModeContext'
import ListPageHeader from '@shared/ListPageHeader'
import StockTakingListView from '@shared/stock_takings/StockTakingListView'
import StockTakingConceptModal from '@shared/stock_takings/StockTakingConceptModal'

import { stockTakingService } from '@services/operator/stockTakingService'

import VirtualCreate from './VirtualCreate'

export default function OperatorStockTakingsList() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { addJob } = useOperatorNotification()
  const { isVirtual } = useStorageMode()
  const [conceptModalVisible, setConceptModalVisible] = useState(false)
  const [virtualCreateOpen, setVirtualCreateOpen] = useState(false)

  return (
    <div>
      <ListPageHeader
        items={[
          { label: t('operator.menu.stocks.title') },
          { label: t('operator.menu.stock_takings.title') },
        ]}
        guideButton={
          <Tooltip title={t('concepts.stock_takings.tooltip')}>
            <Button
              type="text"
              size="small"
              icon={<QuestionCircleFilled style={{ color: '#1890ff' }} />}
              onClick={() => setConceptModalVisible(true)}
              style={{ padding: 0, height: 'auto', minWidth: 'auto' }}
            />
          </Tooltip>
        }
        actions={
          isVirtual ? (
            <Button type="primary" icon={<PlusOutlined />} onClick={() => setVirtualCreateOpen(true)}>
              {t('shared.stock_takings.virtual_create.open_button')}
            </Button>
          ) : (
            <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/stock_takings/new')}>
              {t('common.button.new')}
            </Button>
          )
        }
      />
      <StockTakingListView
        service={stockTakingService}
        role="operator"
        addJob={addJob}
      />
      <StockTakingConceptModal
        visible={conceptModalVisible}
        onClose={() => setConceptModalVisible(false)}
      />
      <VirtualCreate
        open={virtualCreateOpen}
        onClose={() => setVirtualCreateOpen(false)}
      />
    </div>
  )
}
